'use strict';
module.exports = {
	/*api host*/
	// host: ""
	host: 'https://pf.xingtouyan.com'
};



//////////////////
// WEBPACK FOOTER
// ./config/global.js
// module id = 5N5f
// module chunks = 1